// extracted by mini-css-extract-plugin
export default {"container":"breadcrumb_container__49nGF"};